import { createPropertySelectors, Selector } from '@ngxs/store';
import { LoadableStatus } from '@aiwyn/shared';
import { CxpDeliverableDetail } from '../models';
import { CxpDeliverableDetailState } from './cxp-deliverable-detail.state';
import { CxpDeliverableDetailStateModel } from './cxp-deliverable-detail.model';

export interface CxpDeliverableDetailViewModel {
  detail: CxpDeliverableDetail | null;
  isLoading: boolean;
  isLoaded: boolean;
  hasError: boolean;
}

export class CxpDeliverableDetailSelectors {
  static readonly slices = createPropertySelectors<CxpDeliverableDetailStateModel>(CxpDeliverableDetailState);

  @Selector([CxpDeliverableDetailSelectors.slices.selectedDeliverableId])
  static getSelectedDeliverableId(selectedDeliverableId: number | null): number | null {
    return selectedDeliverableId;
  }

  /**
   * Combined view object — the container reads ONE signal of this and derives
   * everything it needs (per `cxp-state` skill rule: "components observe ONE
   * memoized selector, not signal-per-property").
   */
  @Selector([CxpDeliverableDetailSelectors.slices.detail, CxpDeliverableDetailSelectors.slices.status])
  static getViewModel(detail: CxpDeliverableDetail | null, status: LoadableStatus): CxpDeliverableDetailViewModel {
    return {
      detail,
      isLoading: status === LoadableStatus.LOADING,
      isLoaded: status === LoadableStatus.LOADED,
      hasError: status === LoadableStatus.ERROR,
    };
  }
}
